import { ACCOUNT_DELETE_COPY, BRAND } from '@saesak/shared';
import { SiteFooter } from './SiteFooter';

/**
 * 계정 삭제 공개 안내 (§14.1 스토어 요건) — 플레이스토어 데이터 보안 설문의
 * "계정 삭제 요청 URL"로 등록하는 페이지. 로그인 없이 접근 가능해야 한다.
 */
export function AccountDeletionPage() {
  return (
    <main className="mx-auto w-full max-w-screen-sm px-6 py-10">
      <div className="mb-8 flex flex-col items-center gap-2 text-center">
        <img src="/brand-icon.svg" alt="" width={56} height={56} />
        <h1 className="text-2xl font-bold">{ACCOUNT_DELETE_COPY.webGuideTitle}</h1>
        <p className="text-base text-ink-sub">
          {BRAND.name} 계정과 개인정보 삭제는 앱 안에서 직접 처리할 수 있어요.
        </p>
      </div>

      <section className="card p-5">
        <h2 className="text-lg font-bold">앱에서 삭제하기</h2>
        <ol className="mt-2 flex flex-col gap-1.5 text-base text-ink-sub">
          {ACCOUNT_DELETE_COPY.webGuideSteps.map((step, index) => (
            <li key={step}>
              {index + 1}. {step}
            </li>
          ))}
        </ol>
        <p className="mt-3 text-sm text-ink-sub">{ACCOUNT_DELETE_COPY.webGuideAlt}</p>
      </section>

      <section className="card mt-4 p-5">
        <h2 className="text-lg font-bold">무엇이 삭제되나요?</h2>
        <p className="mt-2 text-sm font-semibold">{ACCOUNT_DELETE_COPY.removedTitle}</p>
        <ul className="mt-1 flex flex-col gap-1 text-sm text-ink-sub">
          {ACCOUNT_DELETE_COPY.removedItems.map((item) => (
            <li key={item}>· {item}</li>
          ))}
        </ul>
        <p className="mt-3 text-sm font-semibold">{ACCOUNT_DELETE_COPY.keptTitle}</p>
        <ul className="mt-1 flex flex-col gap-1 text-sm text-ink-sub">
          {ACCOUNT_DELETE_COPY.keptItems.map((item) => (
            <li key={item}>· {item}</li>
          ))}
        </ul>
        <p className="mt-3 text-sm text-ink-sub">{ACCOUNT_DELETE_COPY.directorNote}</p>
      </section>

      <SiteFooter />
    </main>
  );
}
